/**
 * Layout-aware `sizes` presets for ResponsiveImage / next/image.
 * Pass these at the call site that knows the display layout so the browser
 * picks a Storyblok `/m/{w}x0` transform near the rendered width.
 */
export const IMAGE_SIZES = {
  fullBleed: '100vw',
  half: '(max-width: 768px) 100vw, 50vw',
  halfAtLaptop: '(max-width: 1023px) 100vw, 50vw',
  third: '(max-width: 768px) 100vw, 33vw',
  quarter: '(max-width: 768px) 50vw, 25vw',
  cardCarousel: '(max-width: 768px) 80vw, 25vw',
  carouselSlide: '(max-width: 768px) 95vw, 57vw',
  storyCard: '78vw',
  modalNearFull: '95vw',
  fixed: width => `${width}px`,
};
